import React, { Component, Fragment } from 'react';
import { Row, Col, FormGroup, Label, Input, Button, ButtonGroup, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { HorizontalSeparator } from '../Shared/SharedComponents';
import { API } from '../../Logic/API';

export class ManageGameTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newGame: "",
            isDropdownOpen : false,
            selectedGame: { Name : "Spiel wählen" }
        };
    }

    toggleDropdown() {
        this.setState(prevState => ({
            isDropdownOpen: !prevState.isDropdownOpen
        }));
    }

    selectGame(game) {
        this.setState({
            selectedGame : game
        });
    }

    gameSelected() {
        return this.state.selectedGame && this.state.selectedGame.Id;
    }

    newGameChanged(name) {
        this.setState({ newGame: name });
    }

    canCreate() {
        return this.state.newGame !== null && this.state.newGame.length > 0;
    }

    create() {
        let dto = {
            'Name': this.state.newGame
        };

        API.post('/gamehost/games', dto)
            .then(resp => resp.json())
            .then(data => {
                this.setState({ newGame: "" });
                this.props.refreshGames();
            })
            .catch(e => {

            });
    }

    changeName(name) {
        this.setState(prevState => ({
            selectedGame: {
                ...prevState.selectedGame,
                Name : name
            }
        }));
    }

    toggleShowResults() {
        this.setState(prevState => ({
            selectedGame: {
                ...prevState.selectedGame,
                ShowResults: !prevState.selectedGame.ShowResults
            }
        }));
    }

    toggleIsOpen() {
        this.setState(prevState => ({
            selectedGame: {
                ...prevState.selectedGame,
                IsOpen : !prevState.selectedGame.IsOpen
            }
        }));
    }

    updateGame() {
        let dto = this.state.selectedGame;

        API.post(`/gamehost/games/update`, dto)
            .then(resp => resp.json())
            .then(data => {
                this.props.refreshGames();
                this.setState({ selectedGame: data });
            })
            .catch(e => {

            });
    }
    
    renderLoadingDropdown() {
        return (
            <Dropdown disabled toggle={() => { }}>
                <DropdownToggle caret>
                    Laden...
                </DropdownToggle>
            </Dropdown>
        );
    }

    renderName(game) {
        return `${game.Name} (${new Date(game.CreatedAtUtc).toLocaleDateString('de-CH')})`;
    }

    renderDropdown() {
        if (this.props.isLoadingGames) {
            return this.renderLoadingDropdown();
        }
        let games = this.props.games;
        return (
            <Dropdown direction="right" isOpen={this.state.isDropdownOpen} toggle={() => this.toggleDropdown()}>
                <DropdownToggle color="primary" caret>
                    {this.state.selectedGame.Name}
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem header>Offen</DropdownItem>
                    {games.filter(g => g.IsOpen).map(g =>
                        <DropdownItem key={g.Id} onClick={() => this.selectGame(g)}>{this.renderName(g)}</DropdownItem>
                    )}
                    <DropdownItem divider/>
                    <DropdownItem header>Geschlossen</DropdownItem>
                    {games.filter(g => !g.IsOpen).map(g =>
                        <DropdownItem key={g.Id} onClick={() => this.selectGame(g)}>{this.renderName(g)}</DropdownItem>
                    )}
                </DropdownMenu>
            </Dropdown>

        );
    }

    render() {
        let allGamesDropdown = this.renderDropdown();

        return (
            <Fragment>
                <Row className="space-top" >
                    <Col>
                        <FormGroup>
                            <Label for="newGame">Neues Spiel</Label>
                            <Input type="text" palceholder="Name" id="newGame" value={this.state.newGame} onChange={e => this.newGameChanged(e.target.value)} />
                        </FormGroup>
                        <Button type="button" block size="md" color={this.canCreate() ? "primary" : "secondary"} onClick={() => this.create()} disabled={!this.canCreate()}>Eröffnen</Button>
                    </Col>
                </Row>
                <Row>
                    <Col><HorizontalSeparator /></Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>Bestehende Spiele</Label>
                            {allGamesDropdown}
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Input type="text" value={this.gameSelected() ? this.state.selectedGame.Name : ""} onChange={e => this.changeName(e.target.value)} />
                    </Col>
                </Row>
                <Row className="space-top">
                    <Col>
                        <ButtonGroup>
                            <Button color={this.gameSelected() ? (this.state.selectedGame.ShowResults ? "success" : "danger") : "secondary"} active={this.gameSelected() && this.state.selectedGame.ShowResults} onClick={() => this.toggleShowResults()} disabled={!this.gameSelected()}>Show Results</Button>
                        </ButtonGroup>
                    </Col>
                    <Col xs="1" />
                    <Col>
                        <ButtonGroup>
                            <Button color={this.gameSelected() && this.state.selectedGame.IsOpen ? "success" : "secondary"} active={this.gameSelected() && this.state.selectedGame.IsOpen} onClick={() => this.toggleIsOpen()} disabled={!this.gameSelected()}>Offen</Button>
                            <Button color={this.gameSelected() && !this.state.selectedGame.IsOpen ? "danger" : "secondary"} active={this.gameSelected() && !this.state.selectedGame.IsOpen} onClick={() => this.toggleIsOpen()} disabled={!this.gameSelected()}>Geschlossen</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
                <Row className="space-top">
                    <Col>
                        <Button type="button" block size="md" color={this.gameSelected() ? "primary" : "secondary"} onClick={() => this.updateGame()} disabled={!this.gameSelected()}>Speichern</Button>
                    </Col>
                </Row>
            </Fragment>
            );
    }
}


// WEBPACK FOOTER //
// ./src/components/Admin/ManageGameTab.jsx